const formatCurrency = ({ value }) => {
  // Formatear el valor como moneda mexicana
  const formattedCurrency = parseFloat(value).toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
  return <span>{formattedCurrency}</span>;
};

export default formatCurrency;
